// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_OME","left":"styles_left__2jZzd","desktopActions":"styles_desktopActions__1zpOo","title":"styles_title__IecAs"};